export function withUtm(url: string, source: string, medium = "blog", campaign?: string): string {
  try {
    const u = new URL(
      url,
      typeof window !== "undefined" ? window.location.origin : "https://lucienai.io"
    );
    const params = u.searchParams;
    if (!params.has("utm_source")) params.set("utm_source", source);
    if (!params.has("utm_medium")) params.set("utm_medium", medium);
    if (campaign && !params.has("utm_campaign")) params.set("utm_campaign", campaign);
    u.search = params.toString();
    return u.toString();
  } catch {
    return url;
  }
}
